import { render } from "./CategoryUpdatePage.vue?vue&type=template&id=242ebfe8"
import script from "./CategoryUpdatePage.vue?vue&type=script&lang=js"
export * from "./CategoryUpdatePage.vue?vue&type=script&lang=js"

import exportComponent from "/Users/abiinteriors/Documents/WorkSpace/abi-content-manager/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__